if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/request-interceptor.js").catch((e) => {
    console.warn(e);
  });
}
